import {axiosPostAuthorize,axiosGetAuthorize} from '../AxiosRequests';
import {GetProductsList,DeleteProducts,UpdateProducts,GetProductsById,AddProducts} from '../ApiEndPoints';

export default class ProductService {

        //** Call API : */
        async addProducts(request) {
            return axiosPostAuthorize(AddProducts, request);
        }

        async updateProducts(request) {
            return axiosPostAuthorize(UpdateProducts, request);
        }

        async deleteProducts(request) {
            return axiosPostAuthorize(DeleteProducts, request);
        }
        
        async getProductsById(request) {
            return axiosGetAuthorize(GetProductsById, request);
        }

        async getProductsList(request){
            return axiosPostAuthorize(GetProductsList, request);
        }     
   
}